import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../Assets/logo.png";
import "./PurchasePrint.css";

const PurchaseGSTPrint = () => {
    const [purchaseData, setPurchaseData] = useState(null);
    const { filter } = useParams();

    const dummyPurchaseData = {
        date: new Date().toISOString().split('T')[0],
        summary: {
            total_invoices: 8,
            grand_total: 120330.00,
            total_gst: 18330.00,
            total_taxable_value: 102000.00,
            total_cgst: 6315.00,
            total_sgst: 6315.00,
            total_igst: 5700.00,
            total_suppliers: 5,
            pending_payments: 2
        },
        transactions: [
            {
                id: 1,
                purchaseDate: "2025-11-21",
                invoiceNumber: "INV-001",
                supplierName: "SSS Enterprises",
                supplierGSTIN: "07AABCU9603R1ZM",
                taxableValue: 10000.00,
                cgstAmount: 900.00,
                sgstAmount: 900.00,
                igstAmount: 0.00,
                totalGST: 1800.00,
                totalAmount: 11800.00,
                purchaseType: "Regular",
                paymentStatus: "Paid"
            },
            {
                id: 2,
                purchaseDate: "2025-11-20",
                invoiceNumber: "INV-002",
                supplierName: "ABC Suppliers",
                supplierGSTIN: "27BXYPS1205Q2Z4",
                taxableValue: 7500.00,
                cgstAmount: 675.00,
                sgstAmount: 675.00,
                igstAmount: 0.00,
                totalGST: 1350.00,
                totalAmount: 8850.00,
                purchaseType: "Regular",
                paymentStatus: "Pending"
            },
            {
                id: 3,
                purchaseDate: "2025-11-19",
                invoiceNumber: "INV-003",
                supplierName: "XYZ Traders",
                supplierGSTIN: "09PQRSM7896L3T8",
                taxableValue: 15000.00,
                cgstAmount: 0.00,
                sgstAmount: 0.00,
                igstAmount: 2700.00,
                totalGST: 2700.00,
                totalAmount: 17700.00,
                purchaseType: "Interstate",
                paymentStatus: "Paid"
            },
            {
                id: 4,
                purchaseDate: "2025-11-18",
                invoiceNumber: "INV-004",
                supplierName: "Global Imports",
                supplierGSTIN: "24ABCDE1234F5G6",
                taxableValue: 20000.00,
                cgstAmount: 1800.00,
                sgstAmount: 1800.00,
                igstAmount: 0.00,
                totalGST: 3600.00,
                totalAmount: 23600.00,
                purchaseType: "Regular",
                paymentStatus: "Paid"
            },
            {
                id: 5,
                purchaseDate: "2025-11-17",
                invoiceNumber: "INV-005",
                supplierName: "SSS Enterprises",
                supplierGSTIN: "07AABCU9603R1ZM",
                taxableValue: 8000.00,
                cgstAmount: 720.00,
                sgstAmount: 720.00,
                igstAmount: 0.00,
                totalGST: 1440.00,
                totalAmount: 9440.00,
                purchaseType: "Regular",
                paymentStatus: "Paid"
            },
            {
                id: 6,
                purchaseDate: "2025-11-16",
                invoiceNumber: "INV-006",
                supplierName: "Metro Traders",
                supplierGSTIN: "33MMTTS5566K9L0",
                taxableValue: 12000.00,
                cgstAmount: 1080.00,
                sgstAmount: 1080.00,
                igstAmount: 0.00,
                totalGST: 2160.00,
                totalAmount: 14160.00,
                purchaseType: "Regular",
                paymentStatus: "Pending"
            },
            {
                id: 7,
                purchaseDate: "2025-11-15",
                invoiceNumber: "INV-007",
                supplierName: "National Suppliers",
                supplierGSTIN: "06NATSL7890M1N2",
                taxableValue: 25000.00,
                cgstAmount: 0.00,
                sgstAmount: 0.00,
                igstAmount: 4500.00,
                totalGST: 4500.00,
                totalAmount: 29500.00,
                purchaseType: "Interstate",
                paymentStatus: "Paid"
            },
            {
                id: 8,
                purchaseDate: "2025-11-14",
                invoiceNumber: "INV-008",
                supplierName: "ABC Suppliers",
                supplierGSTIN: "27BXYPS1205Q2Z4",
                taxableValue: 6000.00,
                cgstAmount: 540.00,
                sgstAmount: 540.00,
                igstAmount: 0.00,
                totalGST: 1080.00,
                totalAmount: 7080.00,
                purchaseType: "Regular",
                paymentStatus: "Paid"
            }
        ]
    };

    useEffect(() => {
        setPurchaseData(dummyPurchaseData);
        setTimeout(() => window.print(), 800);
    }, [filter]);

    if (!purchaseData) return null;

    const getStatusColor = (status) => {
        switch(status) {
            case 'Paid': return '#28a745';
            case 'Pending': return '#ffc107';
            default: return '#6c757d';
        }
    };

    const getPurchaseTypeColor = (type) => {
        switch(type) {
            case 'Interstate': return '#17a2b8';
            case 'Regular': return '#007bff';
            default: return '#6c757d';
        }
    };

    return (
        <div className="print-page">
            {/* FULL PAGE BORDER */}
            <div className="page-border"></div>

            <div className="print-content">
                {/* HEADER */}
                <div className="header-section">
                    <div>GSTIN No: 33ABCDE1234F1Z5</div>
                    <div className="title">PURCHASE GST REPORT</div>
                </div>

                {/* COMPANY BLOCK */}
                <div className="company-section">
                    <img src={Logo} width="70" alt="logo" />

                    <div className="company-details">
                        <h2>SDS POLYTECHNIC</h2>
                        <div>College Road, Campus Area</div>
                        <div>Coimbatore, Tamil Nadu - 641012</div>
                        <div>Mobile: 0422-1234567</div>
                    </div>
                </div>

                {/* REPORT INFO */}
                <div className="bill-info">
                    <div><b>Report Date:</b> {new Date(purchaseData.date).toLocaleDateString('en-IN')}</div>
                    <div><b>Generated On:</b> {new Date().toLocaleDateString('en-IN')}</div>
                    <div><b>Total Invoices:</b> {purchaseData.summary.total_invoices}</div>
                </div>

                {/* SUMMARY SECTION */}
                <div style={{ marginBottom: '15px', padding: '10px', border: '1px solid #000', fontSize: '13px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div><b>Grand Total:</b> ₹{purchaseData.summary.grand_total.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        <div><b>Total GST:</b> ₹{purchaseData.summary.total_gst.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        <div><b>Taxable Value:</b> ₹{purchaseData.summary.total_taxable_value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                        <div><b>Total Suppliers:</b> {purchaseData.summary.total_suppliers}</div>
                        <div><b>Pending Payments:</b> {purchaseData.summary.pending_payments}</div>
                    </div>
                </div>

                {/* PURCHASE TRANSACTIONS TABLE */}
                <table className="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Purchase Date</th>
                            <th>Invoice No</th>
                            <th>Supplier Name</th>
                            <th>Supplier GSTIN</th>
                            <th>Taxable Value</th>
                            <th>CGST</th>
                            <th>SGST</th>
                            <th>IGST</th>
                            <th>Total GST</th>
                            <th>Total Amount</th>
                            <th>Type</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {purchaseData.transactions.map((transaction, index) => (
                            <tr key={transaction.id}>
                                <td>{index + 1}</td>
                                <td><strong>{transaction.purchaseDate}</strong></td>
                                <td>{transaction.invoiceNumber}</td>
                                <td>{transaction.supplierName}</td>
                                <td>{transaction.supplierGSTIN}</td>
                                <td style={{ textAlign: 'right' }}>₹{transaction.taxableValue.toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{transaction.cgstAmount > 0 ? `₹${transaction.cgstAmount.toFixed(2)}` : '-'}</td>
                                <td style={{ textAlign: 'right' }}>{transaction.sgstAmount > 0 ? `₹${transaction.sgstAmount.toFixed(2)}` : '-'}</td>
                                <td style={{ textAlign: 'right' }}>{transaction.igstAmount > 0 ? `₹${transaction.igstAmount.toFixed(2)}` : '-'}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>₹{transaction.totalGST.toFixed(2)}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>₹{transaction.totalAmount.toFixed(2)}</td>
                                <td>
                                    <span style={{
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        backgroundColor: getPurchaseTypeColor(transaction.purchaseType),
                                        color: 'white'
                                    }}>
                                        {transaction.purchaseType}
                                    </span>
                                </td>
                                <td>
                                    <span style={{
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        backgroundColor: getStatusColor(transaction.paymentStatus),
                                        color: 'white'
                                    }}>
                                        {transaction.paymentStatus}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* GST BREAKDOWN */}
                <div style={{ marginTop: '20px', fontSize: '13px' }}>
                    <b>GST Breakdown:</b>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: '8px', gap: '10px' }}>
                        <div><b>CGST Total:</b> ₹{purchaseData.summary.total_cgst.toFixed(2)}</div>
                        <div><b>SGST Total:</b> ₹{purchaseData.summary.total_sgst.toFixed(2)}</div>
                        <div><b>IGST Total:</b> ₹{purchaseData.summary.total_igst.toFixed(2)}</div>
                        <div><b>Total GST:</b> ₹{purchaseData.summary.total_gst.toFixed(2)}</div>
                    </div>
                </div>

                {/* FINAL SUMMARY */}
                <div style={{ marginTop: '15px', padding: '8px', borderTop: '1px solid #000', fontSize: '13px', fontWeight: 'bold' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>Net Purchase Value (After GST):</div>
                        <div>₹{purchaseData.summary.grand_total.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
                    </div>
                </div>

                {/* SIGNATURE */}
                <div className="signature-section">
                    <b>For SDS POLYTECHNIC</b>
                    <br /><br /><br />
                    <b>Authorized Signature</b>
                </div>

                <div className="footer-text">
                    This is a Computer Generated Purchase GST Report
                </div>
            </div>
        </div>
    );
};

export default PurchaseGSTPrint;